import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/consult';
import List from '../../List/List';
import {EDUCATIONAL_PLAN} from "../../../../../utility/variables";
import {resetStore} from "../../../../../redux/modules/login";


const ms2p = (state) => {
    return {
        ...state.consult,
        titulo: 'PLAN EDUCACIONAL',
        show_list: EDUCATIONAL_PLAN,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(List);
